/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Name_PlaceholderInputs */

const en_options_api_keys_name_placeholder = /** @type {(inputs: Options_Api_Keys_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a name for the key`)
};

const fr_options_api_keys_name_placeholder = /** @type {(inputs: Options_Api_Keys_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisir un nom pour la clé`)
};

const de_options_api_keys_name_placeholder = /** @type {(inputs: Options_Api_Keys_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie einen Namen für den Schlüssel ein.`)
};

const it_options_api_keys_name_placeholder = /** @type {(inputs: Options_Api_Keys_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un nome per la chiave`)
};

const ru_options_api_keys_name_placeholder = /** @type {(inputs: Options_Api_Keys_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите название для ключа.`)
};

const es_options_api_keys_name_placeholder = /** @type {(inputs: Options_Api_Keys_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca un nombre para la clave`)
};

const zh_cn2_options_api_keys_name_placeholder = /** @type {(inputs: Options_Api_Keys_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入密钥的名称`)
};

const ja_options_api_keys_name_placeholder = /** @type {(inputs: Options_Api_Keys_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーの名前を入力してください`)
};

const hi_options_api_keys_name_placeholder = /** @type {(inputs: Options_Api_Keys_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुंजी के लिए एक नाम दर्ज करें`)
};

const pt_pt2_options_api_keys_name_placeholder = /** @type {(inputs: Options_Api_Keys_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira um nome para a chave.`)
};

/**
* | output |
* | --- |
* | "Enter a name for the key" |
*
* @param {Options_Api_Keys_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_name_placeholder = /** @type {((inputs?: Options_Api_Keys_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_name_placeholder(inputs)
	if (locale === "de") return de_options_api_keys_name_placeholder(inputs)
	if (locale === "it") return it_options_api_keys_name_placeholder(inputs)
	if (locale === "ru") return ru_options_api_keys_name_placeholder(inputs)
	if (locale === "es") return es_options_api_keys_name_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_name_placeholder(inputs)
	if (locale === "ja") return ja_options_api_keys_name_placeholder(inputs)
	if (locale === "hi") return hi_options_api_keys_name_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_name_placeholder(inputs)
	return en_options_api_keys_name_placeholder(inputs)
});